import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9fb92a60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "UpdateStatus_Content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "UpdateStatus_Header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "UpdateStatus_Header_Title" }, "VAN強制ステータス 変更履歴")
], -1))
const _hoisted_3 = { class: "UpdateStatus_Main" }
const _hoisted_4 = { class: "UpdateStatus_Table" }
const _hoisted_5 = { class: "UpdateStatus_Table_Yoko" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "入力ユーザー", -1))
const _hoisted_7 = { class: "UpdateStatus_Table_Yoko" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "書誌CD", -1))
const _hoisted_9 = { class: "UpdateStatus_Table_Yoko" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "JANCD", -1))
const _hoisted_11 = { class: "UpdateStatus_Table_Yoko" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "ISBN", -1))
const _hoisted_13 = { class: "UpdateStatus_Table_Yoko" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "書誌名", -1))
const _hoisted_15 = { class: "UpdateStatus_Table_Yoko" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "在庫ステータス", -1))
const _hoisted_17 = { class: "UpdateStatus_Table_Yoko" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("適用"),
  /*#__PURE__*/_createElementVNode("br", { class: "Modal_Index" }),
  /*#__PURE__*/_createTextVNode("期間")
], -1))
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "UpdateStatus_Table_MukigenCheck" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mukigenCheck" }, "無期限", -1))
const _hoisted_23 = ["checked"]
const _hoisted_24 = { class: "UpdateStatus_Table_Yoko" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "入力日時", -1))

import axios from "axios";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { Notyf } from "notyf";


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateStatusLog',
  emits: ["showGlobalHeader", "toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
emit("toggleGlobalHeader");
const route = useRoute();
const store = useStore();
const notyf = new Notyf();

// データ取得--------------------------------------------------
const display_data = ref({
  username: "",
  janCd: "",
  isbn: "",
  syosiCd: "",
  title: "",
  zsId: "",
  zsName: "",
  fromUpdateStatusDate: "",
  toUpdateStatusDate: "",
  processingTime: "",
});
const getLogData = async () => {
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/syosi/log-status?uuid=${route.query.uuid}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    display_data.value = res.data;
    setShowKigen();
  } catch (error) {
    notyf.error("データを取得できませんでした");
    console.log(error);
  }
};
getLogData();

// 表示期間関連-----------------------------------------------
const isMukigen = ref(false);
const date_from = ref(null as string | null);
const date_to = ref(null as string | null);
const setShowKigen = () => {
  if (display_data.value.toUpdateStatusDate === "9999-12-31") {
    isMukigen.value = true;
    date_from.value = null;
    date_to.value = null;
  } else {
    isMukigen.value = false;
    date_from.value = display_data.value.fromUpdateStatusDate;
    date_to.value = display_data.value.toUpdateStatusDate;
  }
};
// 日付形式-------------------------------------------------------------
const convertDate = (registerDate: string) => {
  const targetDate = new Date(registerDate);
  const year = targetDate.getFullYear();
  const month = targetDate.getMonth() + 1;
  const day = targetDate.getDate();
  const hour = targetDate.getHours();
  const minutes = targetDate.getMinutes();
  const seconds = targetDate.getSeconds();
  return `${year}/${month}/${day} ${String(hour).padStart(2, "0")}:${String(
    minutes
  ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("tr", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("td", null, _toDisplayString(display_data.value.username), 1)
        ]),
        _createElementVNode("tr", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("td", null, _toDisplayString(display_data.value.syosiCd), 1)
        ]),
        _createElementVNode("tr", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("td", null, _toDisplayString(display_data.value.janCd), 1)
        ]),
        _createElementVNode("tr", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("td", null, _toDisplayString(display_data.value.isbn), 1)
        ]),
        _createElementVNode("tr", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("td", null, _toDisplayString(display_data.value.title), 1)
        ]),
        _createElementVNode("tr", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("td", null, _toDisplayString(display_data.value.zsName), 1)
        ]),
        _createElementVNode("tr", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("td", null, [
            _createElementVNode("input", {
              type: "date",
              class: "UpdateStatus_Table_InputDate",
              value: date_from.value,
              disabled: ""
            }, null, 8, _hoisted_19),
            _createTextVNode(" ~ "),
            _createElementVNode("input", {
              type: "date",
              class: "UpdateStatus_Table_InputDate",
              value: date_to.value,
              disabled: ""
            }, null, 8, _hoisted_20),
            _createElementVNode("span", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("input", {
                type: "checkbox",
                id: "mukigenCheck",
                checked: isMukigen.value,
                disabled: ""
              }, null, 8, _hoisted_23)
            ])
          ])
        ]),
        _createElementVNode("tr", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("td", null, _toDisplayString(convertDate(display_data.value.processingTime)), 1)
        ])
      ])
    ])
  ]))
}
}

})